var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermConditionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.418 3.71352H3.33168M10.418 6.71352H3.33168M6.95248 9.71352H3.33168M14.1162 12.142L12.5649 14.0758L11.4079 13.2375M12.8262 9.53381C12.8047 9.53342 12.7833 9.533 12.7617 9.533C10.7884 9.533 9.18863 11.134 9.18863 13.1089C9.18863 13.9163 9.45609 14.6611 9.90703 15.2596M12.8262 9.53381C14.7698 9.56825 16.3348 11.1555 16.3348 13.1089C16.3348 15.0838 14.7351 16.6848 12.7617 16.6848C11.5951 16.6848 10.5592 16.1252 9.90703 15.2596M12.8262 9.53381L12.8262 2.4482C12.8262 1.63038 12.1632 0.967407 11.3454 0.967407H2.79821C1.98038 0.967407 1.31738 1.63038 1.31738 2.4482V13.7788C1.31738 14.5966 1.98038 15.2596 2.79821 15.2596H9.90703",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermConditionIcon);
export default __webpack_public_path__ + "static/media/TermConditionIcon.1c25b380b4f620dc4fc400a783c7d996.svg";
export { ForwardRef as ReactComponent };